import React, { Component } from "react";
import Clientdropdown from './Clientdropdown';
import Builderdropdown from './Builderdropdown';
import Simulationsdropdown from './Simulationsdropdown';
import Chart from './Chart'
import './Main.css';
import Navigation from './Navigation';

import ReactTooltip from 'react-tooltip';
import ReactToPrint from "react-to-print"; // import the Libr - aug3
import { CSVLink, CSVDownload } from 'react-csv';

import {
    Route,
    NavLink,
    HashRouter,
    Switch,
    Redirect
} from "react-router-dom";

import Envelope from './Envelope';
import Calendar from './Calendar';
import Hvac from './Hvac';
import Lighting from './Lighting';

import { pick, keys } from 'lodash';
import { Link } from 'react-router-dom';

import Navcharts from './Navcharts';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// hold all time defaults during login
const defaultOptions = {
    aRoofRValue: 10,
    aWallRValue: 10,
    aDooorInstall: 10,
    aWindowRValue: 10,
    bDoorRValue: 10,
    aDoorRValue: 10,
    occCool: 10,
    occHeat: 10,
    unoccCool: 10,
    unoccHeat: 10,
    janOccCalendar: 1,
    febOccCalendar: 1,
    marOccCalendar: 1,
    aprOccCalendar: 1,
    mayOccCalendar: 1,
    junOccCalendar: 1,
    julOccCalendar: 1,
    augOccCalendar: 1,
    sepOccCalendar: 1,
    octOccCalendar: 1,
    novOccCalendar: 1,
    decOccCalendar: 1,
    janOccHours: 8,
    febOccHours: 8,
    marOccHours: 8,
    aprOccHours: 8,
    mayOccHours: 8,
    junOccHours: 8,
    julOccHours: 8,
    augOccHours: 8,
    sepOccHours: 8,
    octOccHours: 8,
    novOccHours: 8,
    decOccHours: 8,
    janHVACCalendar: 1,
    febHVACCalendar: 1,
    marHVACCalendar: 1,
    aprHVACCalendar: 1,
    mayHVACCalendar: 1,
    junHVACCalendar: 1,
    julHVACCalendar: 1,
    augHVACCalendar: 1,
    sepHVACCalendar: 1,
    octHVACCalendar: 1,
    novHVACCalendar: 1,
    decHVACCalendar: 1,
    janHVACHours: 8,
    febHVACHours: 8,
    marHVACHours: 8,
    aprHVACHours: 8,
    mayHVACHours: 8,
    junHVACHours: 8,
    julHVACHours: 8,
    augHVACHours: 8,
    sepHVACHours: 8,
    octHVACHours: 8,
    novHVACHours: 8,
    decHVACHours: 8,
    janLightingCalendar: 1,
    febLightingCalendar: 1,
    marLightingCalendar: 1,
    aprLightingCalendar: 1,
    mayLightingCalendar: 1,
    junLightingCalendar: 1,
    julLightingCalendar: 1,
    augLightingCalendar: 1,
    sepLightingCalendar: 1,
    octLightingCalendar: 1,
    novLightingCalendar: 1,
    decLightingCalendar: 1,
    janLightingHours: 8,
    febLightingHours: 8,
    marLightingHours: 8,
    aprLightingHours: 8,
    mayLightingHours: 8,
    junLightingHours: 8,
    julLightingHours: 8,
    augLightingHours: 8,
    sepLightingHours: 8,
    octLightingHours: 8,
    novLightingHours: 8,
    decLightingHours: 8,
    spaceLightingSystems: "T-5 Lights",
    hallLightingSystems: "T-8 Lights",
    parkingLightingSystems: "200W HPS Floods",
    exteriorLightingSystems: "200W HPS Floods"
}

class Main extends Component {
    constructor(props) {
        super()
        this.state = {
            simulation: undefined,
            segment: undefined,
            selectedClient: undefined,
            selectedBuilding: undefined,
            selectedSegment: undefined,
            chartData: {},
            noSegmentsFound: false,
            kwhAUC: undefined,
            heatAUC: undefined,
            heatUnits: undefined,
            shouldShowHelpTab: false,

            // if stored options are unavailable
            options: defaultOptions,
            simValues: [],
            heatSimValues: [],
            //toggle data display
            show: true,

            hideModifiedValues: {}
        }
        this.noSegmentsFound = this.noSegmentsFound.bind(this);
        this.showHelpTab = this.showHelpTab.bind(this);
    }

    //toggle table column 
    applylinethrough = (month, simValues, valueType) => {
        // const { show } = this.state;
        // this.setState({ show: !show })
        // const { simValues } = this.state;
        simValues.map(simEntry => {
            if (simEntry.month === month) simEntry.hideModified = !simEntry.hideModified;
            return simEntry;
        });
        const stateKey = valueType === 'kWh' ? 'simValues' : 'heatSimValues';
        this.setState({
            hideModifiedValues: {
                ...this.state.hideModifiedValues,
                [month]: !this.state.hideModifiedValues[month]
            },
            [stateKey]: simValues
        })
    }

    componentWillMount() {
        this.setState({
            segment: this.props.segment
        })

        //maintain user input during log in
        const optionsJson = localStorage.getItem('options');
        if (optionsJson) {
            this.setState({
                options: JSON.parse(optionsJson)
            })
        }
    }

    componentWillReceiveProps(props) {
        if (!props.segment) {
            this.setState({ segment: undefined })
            return;
        }
        this.setState({
            segment: props.segment
        });
    }

    getToken() {
        return localStorage.getItem('id_token');
    }

    onSelectClient = selectedClient => {
        this.setState({ simulation: undefined, selectedClient, simValues: [], heatSimValues: [], selectedBuilding: undefined })
    }

    onSelectBuilding = selectedBuilding => {
        this.setState({
            selectedBuilding,
            selectedSegment: null
        })
    }

    onSelectSegment = (segment, reload, simulationobj) => {
        this.setState({
            selectedSegment: segment,
            options: {
                ...this.state.options,
                ...(!reload ? pick(segment, keys(defaultOptions)) : {})
            }
        }, () => {
            if (!reload) {
                this.setSimulationValues(simulationobj);
            }
        })
    }

    noSegmentsFound(bool) {
        if (bool) {
            this.setState({
                noSegmentsFound: true
            });
        } else {
            this.setState({
                noSegmentsFound: false
            });
        }
    }

    //maintain user input changes
    onOptionsUpdate = update => {
        this.setState({
            options: {
                ...this.state.options,
                ...update
            },

        }, () => localStorage.setItem('options', JSON.stringify(this.state.options)))

    }

    simulate = () => {
        const bearerToken = this.getToken();
        const segment = this.state.selectedSegment;

        this.setState({ isBusy: true }, () => {

            fetch(`https://simulateapiprod.azurewebsites.net/api/simulations/`, {
            // fetch(`https://astcloudrestservice.azurewebsites.net/api/simulations/`, {
                method: 'PUT',
                body: JSON.stringify({
                    clientName: segment.clientName,
                    siteName: segment.siteName,
                    simName: segment.simName,
                    segments: [Object.assign({}, segment, this.state.options)]
                }),
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${bearerToken}`
                },
            }).then(response => response.json()).then(simulation => {
                this.setSimulationValues(simulation);
            })
        })
    }

    setSimulationValues = (simulation) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        // const base = [...months.map(m => simulation.totals[0][`adj${m}TotalKWh`]), simulation.totals[0].adjTotalKWh];
        // const modified = [...months.map(m => simulation.totals[1][`adj${m}TotalKWh`]), simulation.totals[1].adjTotalKWh];

        const kwhAUC = simulation.totals[0].kwhauc
        const heatAUC = simulation.totals[0].heatAUC
        const heatUnits = simulation.totals[0].heatingUnits
        const simValues = [];
        const heatSimValues = [];
        const oldSimValues = this.state.simValues.length ? this.state.simValues : undefined;
        const oldHeatValues = this.state.heatSimValues.length ? this.state.heatSimValues : undefined;
        months.map((m, i) => {
            simValues.push({
                month: m,
                base: simulation.totals[0][`adj${m}TotalKWh`],
                modified: simulation.totals[1][`adj${m}TotalKWh`],
                hideModified: oldSimValues ? oldSimValues[i].hideModified : false
            });
            heatSimValues.push({
                month: m,
                base: simulation.totals[0][`adj${m}TotalHeat`],
                modified: simulation.totals[1][`adj${m}TotalHeat`],
                hideModified: oldHeatValues ? oldHeatValues[i].hideModified : false
            });
            return m;
        });

        const simArr = this.simulationObjToArr(simValues);

        this.setState({
            simulation: simArr,
            simValues: simValues,
            heatSimValues: heatSimValues,
            isBusy: false,
            kwhAUC: kwhAUC,
            heatAUC: heatAUC,
            heatUnits: heatUnits,
            shouldShowHelpTab: false
        })
    }

    simulationObjToArr(sim) {
        const base = [];
        const modified = [];
        let baseSum = 0;
        let modifiedSum = 0;

        sim.map(entry => {
            base.push(entry.base);
            baseSum += entry.base;
            modified.push(entry.modified);
            modifiedSum += entry.modified;
            return entry;
        });

        base.push(baseSum);
        modified.push(modifiedSum);
        return [modified, base];
    }

    //display the chart
    renderChart(isBusy, simValues, labelKey, heatUnits) {
        if (!simValues || !this.state.selectedBuilding || !this.state.selectedClient) {
            return null;
        }

        if (isBusy) {
            return <p className="loading-progress">Loading chart simulation...</p>
        }

        return <Chart chartData={simValues} labelKey={labelKey} heatUnits={heatUnits} building={this.state.selectedBuilding} />
    }

    // display table
    renderTable = (simValues, valueType, auc, units) => {
        if (!simValues.length) {
            return
        }

        // const simulationValues = this.state.simulation;
        // const { simValues } = this.state;
        const renderMonthValue = (type, month) => {
            const arrIndex = type === 'base' ? 1 : 0;
            const monthIndex = months.indexOf(month);
            if (type === 'base') {
                return <td key={month}>{simValues[monthIndex].base}</td>
            }


            // const className = this.state.hideModifiedValues[month] ? 'strike-value' : '';
            const className = simValues[monthIndex].hideModified ? 'strike-value' : '';
            return <td data-tip="Click to include or exclude this dollar value" data-class='tool_tip' key={month}>
                <a href='hide' className={className} onClick={e => { e.preventDefault(); this.applylinethrough(month, simValues, valueType); }}>
                    {simValues[monthIndex].modified}
                </a>
                <ReactTooltip place="top" type="info" effect="solid" />
            </td>

        }

        const baseTotal = simValues.reduce((total, simEntry) => (total + simEntry.base), 0);
        const modifiedTotal = simValues.reduce((total, simEntry) => (total + (simEntry.hideModified ? simEntry.base : simEntry.modified)), 0);
        const differenceTotal = simValues.reduce((total, simEntry) => (total + (simEntry.hideModified ? 0 : (simEntry.modified - simEntry.base))), 0);       

        return (
            <div key={valueType}>
                <table className="cal-table">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            {months.map(month => <th key={month}>{month}</th>)}
                            <th>Totals</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>Base</b></td>
                            {months.map((month, i) => renderMonthValue('base', month, i))}
                            <td data-tip="Base Total" data-class='tool_tip'>{baseTotal} <ReactTooltip place="top" type="info" effect="solid" /> </td>
                        </tr>
                        <tr>
                            <td><b>Modified</b></td>
                            {months.map((month, i) => renderMonthValue('modified', month, i))}
                            <td data-tip="Modified Year Annual Cost" data-class='tool_tip'>{modifiedTotal} <ReactTooltip place="top" type="info" effect="solid" /> </td>
                        </tr>
                        <tr>
                            <td><b>Difference</b></td>
                            {months.map((m, i) => (<td key={i}>{simValues[i].hideModified ? 0 : (simValues[i].modified - simValues[i].base)}</td>))}
                            <td data-tip="Simulated Modified Difference" data-class='tool_tip'>{differenceTotal}<ReactTooltip place="top" type="info" effect="solid" /></td>
                        </tr>
                    </tbody>
                </table>
                <div className="main-totals">
                    <b>Simulated Modified Difference ({units}):</b> <span className="main-smd">{differenceTotal}</span> <br />
                    <b>AUC:</b> <span className="main-auc">$<u>{auc}</u></span> <br />
                    <b>Adjustment Estimated Value:</b> <span className="main-aev"><u>${(differenceTotal * auc).toFixed(0)}</u></span>
                </div>
            </div>
        )
    }

    showHelpTab(val) {
        this.setState({
            shouldShowHelpTab: val === true ? true : false
        });
    }

    getCSVData = (simValues, valueType) => {
        if (!simValues.length) {
            return [];
        }

        const csvData = [];
        const csvHeader = [];
        csvHeader.push("");
        const csvBase = [];
        csvBase.push("Base");
        const csvModified = [];
        csvModified.push("Modified");
        const csvDifference = [];
        csvDifference.push("Difference");

        simValues.map(monthEntry => {
            csvHeader.push(monthEntry.month);
            csvBase.push(monthEntry.base);
            csvModified.push(monthEntry.hideModified ? monthEntry.base : monthEntry.modified);
            csvDifference.push(monthEntry.hideModified ? 0 : (monthEntry.base - monthEntry.modified));
            return monthEntry;
        });

        csvData.push(csvHeader);
        csvData.push(csvBase);
        csvData.push(csvModified);
        csvData.push(csvDifference);

        return csvData;
    }

    render() {
        return (
            <div className="main-container">
                <div className="main-left">
                    <div className="main-form">
                        <div className="form-group">
                            <label className="App-bold" htmlFor="clients">Client Selection:</label>
                            <Clientdropdown onSelect={this.onSelectClient} />
                        </div>
                        <div className="form-group">
                            <label className="App-bold" htmlFor="building">Building Selection:</label>
                            <Builderdropdown
                                client={this.state.selectedClient}
                                onSelect={this.onSelectBuilding}
                                showHelpTab={this.showHelpTab}
                            />
                        </div>
                        {this.state.selectedBuilding && <div>
                            <div className="form-group">
                                <label className="App-bold" htmlFor="segments">Segment Selection:</label>
                                <Simulationsdropdown
                                    building={this.state.selectedBuilding}
                                    onSelect={this.onSelectSegment}
                                    simulation={this.state.simulation}
                                    noSegmentsFound={this.noSegmentsFound}
                                    showHelpTab={this.showHelpTab}
                                />
                            </div>
                            <div className="main-simulate-button">
                                <div>
                                    <button className="btn btn-primary" type="button"
                                        disabled={!this.state.selectedSegment || this.state.isBusy} onClick={this.simulate}>Simulate</button>
                                </div>
                            </div>
                        </div>}
                        <div><hr /></div>
                        <div>
                            <div>
                                <Navigation />
                            </div>
                        </div>
                        <div>
                            <HashRouter>
                                <Switch>
                                    <Route exact path="/envelope" render={() => <Envelope options={this.state.options} onOptionsUpdate={this.onOptionsUpdate} />} />
                                    <Route path="/calendar" render={() => <Calendar options={this.state.options} onOptionsUpdate={this.onOptionsUpdate} />} />
                                    <Route path="/hvac" render={() => <Hvac options={this.state.options} onOptionsUpdate={this.onOptionsUpdate} />} />
                                    <Route path="/lighting" render={() => <Lighting options={this.state.options} onOptionsUpdate={this.onOptionsUpdate} />} />
                                    <Redirect to="/envelope" />
                                </Switch>
                            </HashRouter>
                        </div>
                    </div>
                </div>
                {this.state.selectedBuilding && this.state.selectedSegment && <div className="main-right">
                    <div className="print-chart">
                        <ReactToPrint
                            trigger={() => <a href="#" className="green-lnk">Print Results</a>}
                            content={() => this.componentRef}
                        /></div>

                    <Navcharts renderKWHComponent={() =>
                        (
                            <div className="chart-table-wrapper">
                                <div className="main-chart">
                                    {this.renderChart(this.state.isBusy, this.state.simValues, 'kWh', this.state.heatUnits)}
                                </div>
                                <div><hr /></div>
                                <div className="cal-table">
                                    {this.renderTable(this.state.simValues, 'kWh', this.state.kwhAUC, 'kWh')}
                                    <div className="cal-table-download"><CSVLink className="green-lnk" data={this.getCSVData(this.state.simValues)} >Download Electrical Data</CSVLink></div>
                                </div>
                            </div>
                        )
                    }
                        renderHeatComponent={() => (
                            (
                                <div className="chart-table-wrapper">
                                    <div className="main-chart">
                                        {this.renderChart(this.state.isBusy, this.state.heatSimValues, 'Heat', this.state.heatUnits)}
                                    </div>
                                    <div><hr /></div>
                                    <div className="cal-table">
                                        {this.renderTable(this.state.heatSimValues, 'Heat', this.state.heatAUC, this.state.heatUnits)}
                                        <div className="cal-table-download"><CSVLink className="green-lnk" data={this.getCSVData(this.state.heatSimValues)} >Download Heat Data</CSVLink></div>
                                    </div>
                                </div>
                            )
                        )}
                        client={this.state.selectedClient}
                        building={this.state.selectedBuilding}
                        noSegmentsFound={this.state.noSegmentsFound}
                        shouldShowHelpTab={this.state.shouldShowHelpTab}
                        showHelpTab={this.showHelpTab}
                        ref={el => (this.componentRef = el)}
                    />


                </div>}
                <div className="break"></div>
                <div className="main-spacer"></div>
            </div>
        );
    }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.js